import {
  Scale,
  Users,
  FileText,
  Building2,
  ArrowLeftRight,
  ShieldAlert,
  CreditCard,
  Unlock,
  Sword,
  ShieldOff,
  Baby,
  HeartCrack,
  Skull,
  UserMinus,
  DollarSign,
  Home,
  Landmark,
  BarChart3,
  Banknote,
  Receipt,
  Globe,
  ShoppingBag,
  Laptop,
  Pill,
  ScrollText,
  Briefcase,
  Search,
  AlertTriangle,
  Gavel,
  BookOpen,
  TrendingDown,
  HandCoins,
  Fingerprint,
  BadgeAlert,
  CircleDollarSign,
  ClipboardList,
} from "lucide-react";

export const servicesData = [
  {
    id: "slp",
    icon: Scale,
    title: "Special Leave Petition (SLP)",
    helmetTitle:
      "Special Leave Petition (SLP) Lawyers in Supreme Court | Rai & Associates",
    helmetDescription:
      "Expert legal representation for filing, defending, and arguing Special Leave Petitions (SLPs) before the Supreme Court of India.",
    helmetKeywords:
      "SLP lawyer Supreme Court, Special Leave Petition Article 136, Supreme Court appeal, SLP filing Delhi, civil SLP, criminal SLP, Supreme Court advocate",
    bannerImage:
      "https://images.unsplash.com/photo-1589994965851-a8f479c573a9?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "A Special Leave Petition (SLP) under Article 136 of the Constitution of India is not an ordinary right to appeal, but a discretionary power vested solely in the Supreme Court. At Rai & Associates, we understand that approaching the Apex Court requires exceptional legal acumen, meticulous drafting, and a profound understanding of constitutional and statutory law. Our chambers provide highly specialized representation for clients seeking to challenge unjust orders passed by High Courts or Tribunals across the country.",
      sections: [
        {
          title: "Invoking the Apex Court's Jurisdiction",
          content:
            "The Supreme Court grants special leave only in cases involving substantial questions of law or where a gross miscarriage of justice has occurred. Our legal team conducts rigorous preliminary case evaluations to identify these critical points of law, ensuring that your petition is drafted with precision to cross the strict threshold of admission.",
        },
        {
          title: "Comprehensive Supreme Court Practice",
          content:
            "We handle high-stakes appellate litigation with an emphasis on clarity and aggressive advocacy. Our Supreme Court services include:",
          list: [
            "Drafting & Filing SLP (Civil) and SLP (Criminal)",
            "Review Petitions & Curative Petitions",
            "Challenging High Court & NCLAT/Tribunal Orders",
            "Briefing and Instructing Senior Advocates",
            "Urgent Mentoring for Interim Relief / Stays",
            "Transfer Petitions (Civil & Criminal)",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Securing Urgent Stays",
        desc: "Successfully obtained ex-parte interim stays from the Supreme Court against adverse High Court orders, protecting clients' critical commercial properties and business operations from immediate seizure.",
        img: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Overturning Convictions",
        desc: "Drafted and filed highly technical Criminal SLPs that resulted in the Supreme Court suspending sentences and ultimately overturning wrongful convictions passed by lower appellate courts.",
        img: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "pil",
    icon: Users,
    title: "Public Interest Litigation (PIL)",
    helmetTitle:
      "Public Interest Litigation (PIL) Lawyers in New Delhi | Rai & Associates",
    helmetDescription:
      "Expert legal counsel for filing Public Interest Litigations (PIL) before the Supreme Court and High Courts to protect fundamental rights and social justice.",
    helmetKeywords:
      "PIL lawyer Delhi, Public Interest Litigation Supreme Court, PIL High Court, social justice lawyer, environmental litigation India",
    bannerImage:
      "https://images.unsplash.com/photo-1521791055366-0d553872125f?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Public Interest Litigation (PIL) is a powerful constitutional mechanism designed to protect the rights of the public at large, ensuring that justice is accessible to the marginalized and that executive accountability is maintained. At Rai & Associates, we represent NGOs, activists, and conscientious citizens before the Supreme Court (Under Article 32) and High Courts (Under Article 226) to challenge arbitrary state actions, protect the environment, and uphold human rights.",
      sections: [
        {
          title: "Championing Public Causes",
          content:
            "A PIL cannot be filed for private or political gain; it must strictly address a genuine public wrong. Our chambers possess the constitutional expertise required to draft comprehensive petitions that highlight systemic failures and demand judicial intervention for policy correction.",
        },
        {
          title: "Areas of PIL Expertise",
          content:
            "We actively litigate matters of broader national and societal importance, including:",
          list: [
            "Environmental Protection & Anti-Pollution Measures",
            "Human Rights Violations & Police Brutality",
            "Protection of Marginalized Communities",
            "Challenging Arbitrary Government Policies",
            "Public Health and Civic Infrastructure Failures",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Environmental Conservation",
        desc: "Successfully argued for the halting of illegal commercial activities in ecologically sensitive zones, resulting in court-monitored restoration committees.",
        img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Civic Rights Enforcement",
        desc: "Secured landmark directions from the High Court compelling municipal bodies to upgrade critical public health infrastructure during civic emergencies.",
        img: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "writ-petition",
    icon: FileText,
    title: "Writ Petition",
    helmetTitle:
      "Writ Petition Lawyers in High Court & Supreme Court | Rai & Associates",
    helmetDescription:
      "Aggressive legal representation for enforcing Fundamental Rights through Writ Petitions (Mandamus, Habeas Corpus, Certiorari) in Indian Courts.",
    helmetKeywords:
      "Writ petition lawyer Delhi, Article 226 High Court, Article 32 Supreme Court, Habeas Corpus lawyer, Mandamus, fundamental rights violation",
    bannerImage:
      "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "When the State or its instrumentalities violate an individual's Fundamental Rights, a Writ Petition is the most swift and direct constitutional remedy available. Rai & Associates specializes in invoking the extraordinary jurisdiction of the High Courts (Article 226) and the Supreme Court of India (Article 32) to quash illegal orders, compel public authorities to perform their duties, and secure the immediate release of unlawfully detained persons.",
      sections: [
        {
          title: "Extraordinary Constitutional Remedies",
          content:
            "Writ jurisdiction requires highly technical drafting and an aggressive approach. We meticulously analyze state actions against constitutional parameters to seek immediate interim reliefs and final mandates against government bodies, PSUs, and municipal corporations.",
        },
        {
          title: "Types of Writs We File",
          content:
            "Our chambers handle complex constitutional litigation across all five prerogative writs:",
          list: [
            "Habeas Corpus (Securing release from illegal detention)",
            "Mandamus (Compelling a public authority to perform its duty)",
            "Certiorari (Quashing arbitrary or illegal orders of lower authorities)",
            "Prohibition (Preventing a lower court from exceeding jurisdiction)",
            "Quo Warranto (Challenging illegal occupation of public office)",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Quashing Arbitrary Tender Cancellations",
        desc: "Successfully invoked Writ of Certiorari to strike down the arbitrary cancellation of multi-crore government tenders, protecting our corporate clients' commercial interests.",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Protection of Personal Liberty",
        desc: "Secured immediate release orders via Habeas Corpus for individuals subjected to unlawful preventive detention by state authorities.",
        img: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "cat",
    icon: Building2,
    title: "Central Administrative Tribunal (CAT)",
    helmetTitle:
      "CAT Lawyers in New Delhi | Service Matter Advocates | Rai & Associates",
    helmetDescription:
      "Top-tier legal representation for government employees in service matters before the Central Administrative Tribunal (CAT).",
    helmetKeywords:
      "CAT lawyer Delhi, Central Administrative Tribunal advocate, service matter lawyer, government employee suspension, promotion dispute CAT",
    bannerImage:
      "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The Central Administrative Tribunal (CAT) is a specialized forum established to adjudicate disputes regarding the recruitment and conditions of service of public servants. At Rai & Associates, we provide aggressive and strategic representation for government employees, civil servants, and PSU staff facing unjust administrative actions, ensuring their career trajectory and service benefits are fiercely protected.",
      sections: [
        {
          title: "Specialized Service Law Representation",
          content:
            "Service law requires a deep understanding of complex departmental rules, CCS (CCA) Rules, and administrative precedents. We routinely challenge arbitrary departmental inquiries, biased ACRs (Annual Confidential Reports), and wrongful denials of financial benefits before the Principal Bench and other regional benches of CAT.",
        },
        {
          title: "Matters We Handle at CAT",
          content:
            "We offer comprehensive legal support against vindictive or erroneous administrative actions, including:",
          list: [
            "Wrongful Suspension & Dismissal from Service",
            "Denial or Delay of Promotions (DPC Disputes)",
            "Challenging Arbitrary Transfers",
            "Disciplinary Proceedings & Charge-Sheets",
            "Pension, Gratuity & Retiral Benefit Disputes",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Revocation of Unjust Suspension",
        desc: "Successfully represented senior bureaucrats in obtaining immediate stay orders from CAT against politically motivated suspension orders, reinstating them with full back-wages.",
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Restoring Seniority Rights",
        desc: "Litigated complex seniority disputes resulting in the tribunal ordering the retrospective promotion of our clients along with consequential financial benefits.",
        img: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "tp",
    icon: ArrowLeftRight,
    title: "Transfer Petition (TP)",
    helmetTitle: "Transfer Petition Lawyers Supreme Court | Rai & Associates",
    helmetDescription:
      "Expert legal assistance for filing civil and criminal Transfer Petitions in the Supreme Court to ensure fair trials and convenience in jurisdiction.",
    helmetKeywords:
      "Transfer petition Supreme Court, matrimonial transfer case, TP Civil Supreme court, transfer criminal case, jurisdiction lawyer Delhi",
    bannerImage:
      "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "A Transfer Petition (TP) is a crucial legal remedy utilized when a fair trial is prejudiced due to the current venue, or when participating in proceedings in a distant state poses severe hardship. Rai & Associates frequently files and defends Transfer Petitions before the Supreme Court of India (for inter-state transfers) and High Courts (for intra-state transfers), ensuring our clients face litigation in a jurisdiction that serves the interests of justice.",
      sections: [
        {
          title: "Strategic Venue Management",
          content:
            "The Supreme Court wields expansive powers under Section 25 of the CPC (Civil) and Section 406 of the CrPC (Criminal) to transfer cases. Whether you are a wife seeking to transfer a matrimonial dispute to your home state, or a corporate entity facing malicious parallel FIRs in multiple states, we draft compelling petitions highlighting the balance of convenience and threats to personal safety.",
        },
        {
          title: "Common Grounds for Transfer Petitions",
          content:
            "We successfully secure case transfers based on heavily documented and legally sound grounds, such as:",
          list: [
            "Matrimonial Disputes (Favoring the convenience/safety of the wife)",
            "Reasonable Apprehension of Bias or Unfair Trial",
            "Threat to Life or Physical Safety in the Current Jurisdiction",
            "Consolidation of Multiple FIRs/Cases in Different States",
            "Extreme Financial Hardship or Physical Disability",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Matrimonial Case Transfers",
        desc: "Regularly secure orders from the Supreme Court transferring contested divorce and dowry harassment cases across states, prioritizing the logistical and financial limitations of estranged wives.",
        img: "https://images.unsplash.com/photo-1633526543814-9718c8922b7a?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Consolidating Malicious FIRs",
        desc: "Successfully petitioned the Apex Court to club and transfer multiple overlapping criminal cases filed in different states against corporate directors into a single, neutral jurisdiction.",
        img: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "anticipatory-bail",
    icon: ShieldAlert,
    title: "Anticipatory Bail",
    helmetTitle:
      "Anticipatory Bail Lawyers in Delhi | High Court & Supreme Court",
    helmetDescription:
      "Urgent and aggressive legal representation for securing Anticipatory Bail to protect you from arbitrary arrest and false implication.",
    helmetKeywords:
      "Anticipatory bail lawyer Delhi, Section 438 CrPC, Section 482 BNSS, prevent arrest, high court bail lawyer, false FIR defense",
    bannerImage:
      "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The threat of arbitrary arrest can cause irreparable damage to an individual's personal liberty and professional reputation. Anticipatory Bail is a crucial statutory right designed to protect citizens from being taken into custody due to false or motivated criminal accusations. At Rai & Associates, our criminal defense team acts with utmost urgency, moving the Sessions Court, High Court, or Supreme Court to secure pre-arrest bail and ensure your freedom is protected.",
      sections: [
        {
          title: "Immediate Action & Strategy",
          content:
            "Securing anticipatory bail requires establishing before the court that the accusations are frivolous, politically motivated, or arise out of civil/matrimonial vendettas. We prepare robust applications backed by documentary evidence to demonstrate our clients' willingness to cooperate with the investigation without the necessity of custodial interrogation.",
        },
        {
          title: "Common Grounds for Anticipatory Bail",
          content:
            "We frequently secure pre-arrest protection in highly contentious matters, including:",
          list: [
            "Matrimonial Disputes & Dowry Harassment (Sec 498A)",
            "Economic Offences, Fraud, & Cheating (Sec 420)",
            "Corporate Crimes & EOW Investigations",
            "Defamation and Cyber Crime Allegations",
            "Politically Motivated False FIRs",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Protection in Matrimonial Disputes",
        desc: "Successfully secured blanket protection for entire families falsely implicated in vindictive dowry harassment (498A) and domestic violence cases.",
        img: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "White-Collar Crime Defense",
        desc: "Obtained urgent anticipatory bail for corporate directors and promoters facing sudden arrest threats from the Economic Offences Wing (EOW).",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "cheque-bounce",
    icon: CreditCard,
    title: "Cheque Bounce (N.I. Act)",
    helmetTitle:
      "Cheque Bounce Lawyers in Delhi | Section 138 N.I. Act | Rai & Associates",
    helmetDescription:
      "Expert legal services for recovering funds and defending against Cheque Bounce cases under Section 138 of the Negotiable Instruments Act.",
    helmetKeywords:
      "Cheque bounce lawyer Delhi, Section 138 NI Act, cheque dishonour, debt recovery lawyer, 138 notice drafting, quashing cheque bounce case",
    bannerImage:
      "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Cheque dishonour under Section 138 of the Negotiable Instruments (N.I.) Act is a serious criminal offence in India that can lead to imprisonment and hefty penalties. Whether you are a business owner seeking to recover blocked funds from a defaulted cheque, or an individual falsely accused in a fraudulent cheque bounce claim, Rai & Associates provides aggressive, results-driven litigation strategies.",
      sections: [
        {
          title: "Dual-Sided Expertise",
          content:
            "Cheque bounce litigation requires strict adherence to statutory timelines. Missing the 30-day window to send a legal notice can destroy a recovery case. We handle both prosecution (Complainant) and defense (Accused) with tactical precision, ensuring swift resolution through trial or court-mandated mediation/settlement.",
        },
        {
          title: "Our Specialized Services",
          content:
            "We handle the entire spectrum of financial litigation under the N.I. Act:",
          list: [
            "Drafting & Dispatching Statutory Demand Notices",
            "Filing Section 138 Criminal Complaints",
            "Defending Against Misuse of Security Cheques",
            "Cross-Examination of Financial Evidences",
            "Quashing of 138 Proceedings in High Court",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Corporate Debt Recovery",
        desc: "Successfully recovered multi-crore commercial debts for MSMEs and corporate clients through rapid and aggressive prosecution under Section 138.",
        img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Defending Security Cheque Misuse",
        desc: "Secured acquittals for clients by forensically proving that blank cheques given purely for security purposes were maliciously misused by the complainant.",
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "bail",
    icon: Unlock,
    title: "Regular & Default Bail",
    helmetTitle: "Regular Bail Lawyers in Delhi | Trial Court to Supreme Court",
    helmetDescription:
      "Strategic legal representation for securing Regular and Default Bail for individuals in judicial or police custody.",
    helmetKeywords:
      "Regular bail lawyer, default bail, statutory bail, CrPC bail lawyer Delhi, high court bail, criminal defense attorney",
    bannerImage:
      "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "When an individual is taken into custody, securing their release becomes the most critical priority. At Rai & Associates, we firmly believe in the constitutional principle that 'Bail is the rule, and jail is an exception.' Our criminal defense chambers are highly experienced in moving swift and effective Regular Bail applications before Sessions Courts, High Courts, and the Supreme Court of India.",
      sections: [
        {
          title: "Strategic Bail Advocacy",
          content:
            "Securing bail in serious offences requires a deep analysis of the FIR, the police charge-sheet, and the forensic evidence. We meticulously argue on the grounds of lack of prima facie evidence, the accused's deep roots in society, and parity with co-accused to ensure our clients' liberty is restored.",
        },
        {
          title: "Categories of Bail Mastered",
          content:
            "We provide urgent intervention for individuals in custody through:",
          list: [
            "Regular Bail (Post-Arrest/Judicial Custody)",
            "Default/Statutory Bail (Due to delayed charge-sheet filing)",
            "Interim & Short-Term Bail (For medical or family emergencies)",
            "Bail in Special Statutes (NDPS, PMLA, MCOCA)",
            "Cancellation of Bail (For victims whose accused violate terms)",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Securing Default Bail",
        desc: "Successfully obtained mandatory default bail for clients when investigating agencies failed to file the charge-sheet within the strict 60/90 day statutory limit.",
        img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "High Court Interventions",
        desc: "Secured regular bail from the High Court in complex, high-stakes matters after the lower trial courts had repeatedly dismissed the applications.",
        img: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "murder",
    icon: Skull,
    title: "Murder & Homicide Defense",
    helmetTitle:
      "Murder & Homicide Defense Lawyers in Delhi | Criminal Trial Experts",
    helmetDescription:
      "Top-tier criminal defense attorneys specializing in high-stakes murder, culpable homicide, and violent crime trials.",
    helmetKeywords:
      "Murder defense lawyer Delhi, Section 302 IPC, Section 103 BNS, culpable homicide, violent crimes defense, criminal trial lawyer",
    bannerImage:
      "https://images.unsplash.com/photo-1478860409698-8707f313ee8b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Facing allegations of murder (Section 302 IPC / Section 103 BNS) or culpable homicide is the most severe legal crisis an individual can endure. These high-stakes trials carry the possibility of life imprisonment or capital punishment. Rai & Associates brings a formidable, aggressive, and highly analytical approach to homicide defense, ensuring that the presumption of innocence is fiercely guarded throughout the trial process.",
      sections: [
        {
          title: "Forensic and Tactical Defense",
          content:
            "Homicide trials are rarely won on emotions; they are won by dismantling the prosecution's evidence. Our chambers specialize in cross-examining investigating officers, challenging medico-legal and autopsy reports, and identifying critical gaps in the chain of circumstantial evidence to establish reasonable doubt.",
        },
        {
          title: "Areas of Trial Expertise",
          content:
            "We handle the most complex and serious criminal trials, including:",
          list: [
            "Murder (Sec 302 IPC / 103 BNS)",
            "Culpable Homicide Not Amounting to Murder",
            "Attempt to Murder (Sec 307 IPC / 109 BNS)",
            "Deaths due to Negligence",
            "Defending against Circumstantial Evidence",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Dismantling Circumstantial Evidence",
        desc: "Secured a complete acquittal in a high-profile murder trial by breaking the chain of circumstantial evidence and proving critical lapses in police recovery procedures.",
        img: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Expert Cross-Examination",
        desc: "Turned the tide of complex homicide cases by rigorously cross-examining forensic experts and autopsy surgeons, highlighting fatal contradictions in the medical evidence.",
        img: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "rape",
    icon: ShieldOff,
    title: "Rape & Sexual Offences Defense",
    helmetTitle:
      "Sexual Offences & Rape Defense Lawyers in Delhi | Rai & Associates",
    helmetDescription:
      "Confidential and rigorous legal defense against allegations of rape, sexual assault, and false promise of marriage cases.",
    helmetKeywords:
      "Rape defense lawyer Delhi, Section 376 IPC, Section 63 BNS, false promise of marriage, sexual assault defense, quashing false rape case",
    bannerImage:
      "https://images.unsplash.com/photo-1589994965851-a8f479c573a9?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Allegations of sexual offences are uniquely devastating, carrying immediate social stigma and severe statutory penalties. In recent years, the courts have noted a significant rise in FIRs filed out of personal vendettas, extortion, or the breakdown of consensual relationships (often framed as a 'false promise of marriage'). Rai & Associates provides strictly confidential, non-judgmental, and aggressive defense to protect our clients' liberty, reputation, and future.",
      sections: [
        {
          title: "Strategic Evidence & Cross-Examination",
          content:
            "Defending sexual offence allegations requires immense tact and legal precision. We focus on recovering and analyzing digital evidence (WhatsApp chats, call records, location data) to establish the consensual nature of relationships, and rigorously cross-examine witnesses to expose contradictions in the prosecution's narrative.",
        },
        {
          title: "Scope of Defense Services",
          content:
            "We provide comprehensive defense representation in highly sensitive matters:",
          list: [
            "Rape & Sexual Assault (Sec 376 IPC / 63 BNS)",
            "False Promise of Marriage FIRs",
            "Outraging Modesty & Sexual Harassment",
            "Quashing of False FIRs in the High Court",
            "Bail in Sensitive Crimes Against Women",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "False Promise of Marriage Defense",
        desc: "Successfully quashed multiple FIRs in the High Court by proving that the relationship was entirely consensual and the dispute arose only after a breakdown in compatibility.",
        img: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Digital Evidence Recovery",
        desc: "Secured acquittals and urgent bail by utilizing digital forensics and communication records to expose extortion attempts and fabricated narratives by the complainant.",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "posco",
    icon: Baby,
    title: "POCSO Act Matters",
    helmetTitle: "POCSO Act Lawyers in Delhi | Protection & Defense Attorneys",
    helmetDescription:
      "Specialized and discreet legal representation for matters under the Protection of Children from Sexual Offences (POCSO) Act.",
    helmetKeywords:
      "POCSO lawyer Delhi, POCSO Act defense, child sexual abuse laws, false POCSO case, statutory age defense, POCSO bail lawyer",
    bannerImage:
      "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The Protection of Children from Sexual Offences (POCSO) Act is an extraordinarily stringent law with severe minimum sentences and a legal 'presumption of guilt' against the accused. Due to its strict nature, POCSO is frequently misused as a weapon in bitter custody battles, property disputes, or in cases involving consensual teenage relationships. Rai & Associates offers highly specialized, sensitive, and rigorous legal counsel to navigate the complexities of POCSO trials.",
      sections: [
        {
          title: "Navigating a Presumption of Guilt",
          content:
            "Because the POCSO Act places the burden of proof heavily on the accused, securing bail and fighting the trial requires an elite level of trial advocacy. We focus on verifying age-related documentation (ossification tests, school records) and uncovering the true motives behind delayed or fabricated FIRs.",
        },
        {
          title: "Our Expertise in POCSO Trials",
          content:
            "We handle delicate cases involving minors with absolute confidentiality and legal rigor:",
          list: [
            "Defense against False/Motivated Accusations",
            "Teenage Consensual Relationship Cases (Romeo-Juliet cases)",
            "Securing Bail in High-Stakes Special Courts",
            "Cross-Examination while adhering to Child-Friendly Trial norms",
            "Challenging Age-Determination & Medical Reports",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Teenage Consensual Cases",
        desc: "Secured favorable rulings and bail from High Courts in matters where young adults were unfairly prosecuted under POCSO for consensual teenage romantic relationships.",
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Exposing Motivated Custody FIRs",
        desc: "Secured swift acquittals by demonstrating to the court that POCSO allegations were maliciously fabricated by a spouse solely to gain leverage in an ongoing divorce and child custody dispute.",
        img: "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "domestic-violence",
    icon: HeartCrack,
    title: "Domestic Violence (PWDVA)",
    helmetTitle:
      "Domestic Violence Lawyers in Delhi | Protection Orders | Rai & Associates",
    helmetDescription:
      "Confidential and urgent legal counsel for victims of domestic abuse, and strategic defense against false PWDVA implications.",
    helmetKeywords:
      "Domestic violence lawyer Delhi, PWDVA 2005, protection order, residence order, domestic abuse lawyer, false domestic violence case",
    bannerImage:
      "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Domestic violence represents a profound breach of trust within a household. Under the Protection of Women from Domestic Violence Act (PWDVA) 2005, the law provides swift, civil remedies to protect victims from physical, emotional, and economic abuse. At Rai & Associates, we provide highly confidential and urgent legal interventions. We represent victims seeking immediate sanctuary and financial support, while also providing aggressive defense for individuals falsely implicated in vindictive family disputes.",
      sections: [
        {
          title: "Securing Immediate Relief for Victims",
          content:
            "In cases of genuine abuse, time is of the essence. We swiftly approach the Magistrate to secure emergency ex-parte orders, ensuring the victim's safety, right to residence, and immediate financial sustenance without waiting for lengthy trials.",
        },
        {
          title: "Comprehensive Domestic Violence Litigation",
          content:
            "Our chambers handle the entire spectrum of PWDVA litigation, including:",
          list: [
            "Protection Orders (Preventing further abuse or contact)",
            "Residence Orders (Preventing eviction from the shared household)",
            "Monetary Relief & Maintenance Orders",
            "Child Custody & Temporary Visitation Rights",
            "Strategic Defense against Fabricated/Extortionate PWDVA Petitions",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Securing Right to Residence",
        desc: "Successfully obtained urgent Residence Orders, preventing the unlawful eviction of estranged wives from their matrimonial homes by hostile in-laws.",
        img: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Quashing False DV Claims",
        desc: "Dismantled fabricated domestic violence petitions filed purely to gain leverage in property disputes, exposing the misuse of the statute before the Magistrate.",
        img: "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "dowry",
    icon: Sword,
    title: "Dowry Harassment (Sec 498A)",
    helmetTitle: "Dowry Harassment (498A) Lawyers in Delhi | Rai & Associates",
    helmetDescription:
      "Expert legal representation for dowry harassment victims and robust defense against false 498A FIRs and arbitrary arrests.",
    helmetKeywords:
      "498A lawyer Delhi, Section 498A IPC, Section 85 BNS, dowry harassment defense, false 498A quashing, anticipatory bail 498A",
    bannerImage:
      "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Cruelty and harassment for dowry (Section 498A IPC / Section 85 BNS) is a non-bailable, cognizable offence that frequently becomes the focal point of bitter matrimonial breakdowns. While the law was enacted to protect women from genuine dowry demands, the Supreme Court has repeatedly acknowledged its widespread misuse to settle personal scores. Rai & Associates specializes in handling highly contentious 498A matters, providing elite representation for both genuine victims seeking justice and innocent families facing arbitrary arrests.",
      sections: [
        {
          title: "Pre-Arrest Protection & Mediation",
          content:
            "The immediate threat in a 498A FIR is the arrest of the husband and elderly family members. We specialize in securing swift Anticipatory Bail from Sessions and High Courts, while actively guiding clients through CAW (Crime Against Women) Cell proceedings to prevent the escalation of the dispute.",
        },
        {
          title: "Strategic 498A Litigation Services",
          content:
            "We navigate the complexities of anti-dowry litigation through:",
          list: [
            "Representation at CAW Cell / Parivar Pramarsh Kendra",
            "Securing Anticipatory and Regular Bail for all family members",
            "Quashing of False 498A FIRs in the High Court based on settlements",
            "Trial Defense and Cross-Examination of Complainant's Evidence",
            "Filing Counter-Cases for Defamation and Malicious Prosecution",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Blanket Anticipatory Bail",
        desc: "Successfully secured anticipatory bail for entire extended families by proving that the FIR was a retaliatory afterthought following a divorce filing.",
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "High Court Quashing",
        desc: "Facilitated global settlements in highly toxic matrimonial disputes, leading to the complete quashing of 498A proceedings by the High Court.",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "dowry-death",
    icon: UserMinus,
    title: "Dowry Death (Sec 304B)",
    helmetTitle:
      "Dowry Death (Section 304B) Trial Lawyers in Delhi | Rai & Associates",
    helmetDescription:
      "Top-tier criminal defense attorneys handling high-stakes, complex Dowry Death (Section 304B) and abetment to suicide trials.",
    helmetKeywords:
      "Dowry death lawyer, Section 304B IPC, Section 80 BNS, dowry murder trial, criminal defense lawyer dowry, dowry death acquittal",
    bannerImage:
      "https://images.unsplash.com/photo-1478860409698-8707f313ee8b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "An allegation of Dowry Death (Section 304B IPC / Section 80 BNS) is among the most perilous charges in Indian criminal jurisprudence, carrying a potential sentence of life imprisonment. Unlike most crimes, the law imposes a strict 'Presumption of Guilt' against the accused if a woman dies under unnatural circumstances within seven years of marriage, preceded by dowry harassment. Defending against such charges requires an elite, forensic approach to criminal trial advocacy.",
      sections: [
        {
          title: "Overcoming the Presumption of Guilt",
          content:
            "Because the burden of proof shifts to the defense, mere denials are insufficient. Our trial strategy relies heavily on dismantling the prosecution's timeline, challenging forensic/autopsy reports, and proving that the tragic demise was either natural, accidental, or completely disconnected from any dowry demands.",
        },
        {
          title: "Critical Areas of Trial Defense",
          content:
            "We provide uncompromising defense in these life-altering trials, focusing on:",
          list: [
            "Rigorous Cross-Examination of Medical Experts and Autopsy Surgeons",
            "Challenging Dying Declarations and Witness Testimonies",
            "Proving the Absence of 'Soon Before Death' Harassment",
            "Defending 'Abetment to Suicide' (Sec 306 IPC / Sec 108 BNS) alternative charges",
            "Securing Bail from the High Court and Supreme Court in grievous matters",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Forensic Trial Acquittals",
        desc: "Secured a complete acquittal in a high-profile dowry death trial by using forensic pathology to prove the death was a result of underlying medical complications, not foul play.",
        img: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Breaking the Chain of Harassment",
        desc: "Successfully proved the absence of any dowry demand 'soon before death', neutralizing the statutory presumption and securing freedom for the accused family.",
        img: "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "child-custody",
    icon: Users,
    title: "Child Custody & Guardianship",
    helmetTitle:
      "Child Custody Lawyers in Delhi | Family Law Attorneys | Rai & Associates",
    helmetDescription:
      "Compassionate and aggressive legal representation in high-stakes child custody, guardianship, and visitation disputes.",
    helmetKeywords:
      "Child custody lawyer Delhi, Guardians and Wards Act, visitation rights, shared parenting, custody battle lawyer, child welfare",
    bannerImage:
      "https://images.unsplash.com/photo-1633526543814-9718c8922b7a?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "In any matrimonial dissolution, the battle for child custody is the most emotionally fraught and consequential issue. Indian courts operate on a singular, overriding principle: the 'Paramount Welfare of the Child'. At Rai & Associates, we understand that custody battles require a delicate balance of compassion for the family dynamics and aggressive legal maneuvering to protect your parental rights and your child's future.",
      sections: [
        {
          title: "Strategic Custody Litigation",
          content:
            "A parent's financial superiority does not guarantee custody; courts examine emotional availability, safe environments, and the child's educational stability. We meticulously build cases to demonstrate our client's unparalleled fitness as a primary caregiver, while exposing any hostile or alienating behaviors from the opposing spouse.",
        },
        {
          title: "Types of Custody Arrangements",
          content:
            "We represent mothers, fathers, and occasionally grandparents, in securing various custody structures:",
          list: [
            "Sole Physical Custody (With the primary caregiver)",
            "Joint/Shared Legal Custody (Equal decision-making rights)",
            "Securing Generous Visitation Rights and Holiday Access",
            "Defending Against Parental Alienation Syndrome",
            "International Relocation Disputes involving Minors",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Securing Primary Custody for Fathers",
        desc: "Overcame traditional biases to secure sole physical custody of minor children for fathers, proving the mother's environment was hostile to the child's psychological welfare.",
        img: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Enforcing Interim Visitation",
        desc: "Secured strict, court-mandated weekend visitation orders against spouses who were unlawfully weaponizing the child and preventing access during trial.",
        img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "mainencance",
    icon: DollarSign,
    title: "Maintenance & Alimony",
    helmetTitle: "Maintenance & Alimony Lawyers in Delhi | Rai & Associates",
    helmetDescription:
      "Expert legal counsel for securing fair alimony for spouses/children, and defending against exorbitant, extortionate maintenance claims.",
    helmetKeywords:
      "Alimony lawyer Delhi, Section 125 CrPC, maintenance under Hindu Marriage Act, spouse maintenance, child maintenance, fighting false maintenance claims",
    bannerImage:
      "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Financial security is the bedrock of post-separation life. Maintenance litigation determines the financial obligations of estranged spouses, covering the sustenance of the dependent spouse and the educational needs of children. Whether filing under Section 125 of the CrPC (now Section 144 BNSS), the Hindu Marriage Act, or the PWDVA, Rai & Associates offers highly analytical financial litigation strategies to ensure fair and equitable monetary orders.",
      sections: [
        {
          title: "Securing Rights vs. Defending Assets",
          content:
            "For dependent spouses, we conduct deep financial discovery to uncover hidden assets, corporate holdings, and undisclosed income to secure maximum rightful alimony. Conversely, for primary earners facing exorbitant and extortionate demands, we utilize strict legal precedents to establish the claimant's earning capacity, thereby minimizing or entirely quashing unreasonable financial liabilities.",
        },
        {
          title: "Comprehensive Financial Litigation",
          content:
            "We manage complex financial disputes involving high-net-worth individuals, addressing:",
          list: [
            "Interim Maintenance Applications (Pendente Lite)",
            "Permanent Alimony and Final Settlements",
            "Child Maintenance and Educational Expenses",
            "Exposing Hidden Income through Income Affidavits (Rajnesh v. Neha guidelines)",
            "Filing for Cancellation/Reduction of Maintenance due to changed circumstances",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Uncovering Hidden Wealth",
        desc: "Successfully proved a husband's true earning capacity by auditing proxy business holdings, resulting in the court awarding a significantly enhanced permanent alimony.",
        img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Mitigating Exorbitant Claims",
        desc: "Protected clients from extortionate demands by legally establishing the estranged wife's independent, high-paying career, resulting in a zero-maintenance order.",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "delay-in-possession",
    icon: Home,
    title: "Delay in Possession (RERA & NCDRC)",
    helmetTitle:
      "Delay in Possession Lawyers Delhi | RERA & NCDRC | Rai & Associates",
    helmetDescription:
      "Aggressive legal action against builders for delayed possession. Expert RERA and NCDRC lawyers for refunds, compensation, and flat handovers.",
    helmetKeywords:
      "Delay in possession lawyer Delhi, RERA complaint lawyer, builder delay compensation, NCDRC lawyer, refund from builder, real estate litigation",
    bannerImage:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "For a homebuyer or investor, the failure of a real estate developer to hand over possession on time causes immense financial and emotional distress. At Rai & Associates, we take aggressive legal action against defaulting builders and promoters. Utilizing the Real Estate (Regulation and Development) Act (RERA), the Consumer Protection Act, and the Insolvency and Bankruptcy Code (IBC), we force developers to either deliver the property immediately or refund your hard-earned investments with statutory interest.",
      sections: [
        {
          title: "Strategic Litigation against Builders",
          content:
            "We do not rely on endless negotiations with unresponsive builders. Our chambers initiate swift, multi-pronged litigation to freeze builder assets, secure RERA execution warrants, and compel immediate compliance. We represent individual allottees as well as Homebuyers' Associations.",
        },
        {
          title: "Our Real Estate Litigation Services",
          content:
            "We provide end-to-end representation to secure your property or funds:",
          list: [
            "Filing Complaints before RERA & Real Estate Appellate Tribunals (REAT)",
            "Consumer Complaints before SCDRC & NCDRC for High-Value Claims",
            "Execution Petitions to enforce RERA Recovery Certificates",
            "Initiating Insolvency Proceedings (NCLT) against Bankrupt Builders",
            "Challenging Arbitrary Cancellations and Hidden Builder Demands",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Securing Full Refunds with Interest",
        desc: "Successfully represented associations of homebuyers against tier-1 developers, securing orders from RERA for complete refunds along with 10%+ penal interest for multi-year delays.",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Execution & Asset Attachment",
        desc: "Ensured the actual recovery of funds for clients by driving the District Magistrate to attach and auction the commercial bank accounts and un-sold inventory of defaulting builders.",
        img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "encrochment",
    icon: Landmark,
    title: "Property Encroachment",
    helmetTitle:
      "Property Encroachment & Eviction Lawyers in Delhi | Rai & Associates",
    helmetDescription:
      "Expert civil and criminal litigation to remove illegal encroachment, protect NRI properties, and secure permanent injunctions.",
    helmetKeywords:
      "Encroachment lawyer Delhi, illegal occupation, NRI property dispute, property injunction lawyer, Specific Relief Act, land grabbing defense",
    bannerImage:
      "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Illegal encroachment, land grabbing, and unauthorized occupation of property by trespassers, rogue tenants, or even family members is a severe violation of your ownership rights. This threat is especially critical for Non-Resident Indians (NRIs) and elderly property owners. Rai & Associates employs a highly aggressive combination of civil injunctions and criminal trespass laws to swiftly evict unauthorized occupants and restore your rightful possession.",
      sections: [
        {
          title: "Immediate Civil and Criminal Action",
          content:
            "Time is the most critical factor in encroachment matters. Delaying legal action can allow trespassers to claim adverse possession. We act immediately to file suits under the Specific Relief Act for the recovery of possession, while simultaneously lodging criminal complaints for trespass, forgery, and criminal intimidation.",
        },
        {
          title: "Anti-Encroachment Legal Services",
          content:
            "We protect high-value residential, commercial, and agricultural properties through:",
          list: [
            "Mandatory & Permanent Injunctions (Order 39 CPC) to halt illegal construction",
            "Suits for Recovery of Possession (Eviction of Trespassers)",
            "NRI Property Protection and Boundary Demarcation Suits",
            "Filing FIRs for Land Grabbing, Fraudulent Sale Deeds, and Trespass",
            "Mesne Profit Claims (Financial compensation for the period of illegal occupation)",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "NRI Property Restoration",
        desc: "Successfully reclaimed multi-crore residential properties for NRI clients that were illegally occupied by distant relatives using forged power of attorney documents.",
        img: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Halting Illegal Construction",
        desc: "Secured immediate ex-parte stay orders from the Civil Court against neighbors attempting to encroach upon setbacks and build unauthorized structures on our client's land.",
        img: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "nclt",
    icon: BarChart3,
    title: "National Company Law Tribunal (NCLT)",
    helmetTitle:
      "NCLT Lawyers in Delhi | IBC & Corporate Disputes | Rai & Associates",
    helmetDescription:
      "Expert corporate litigation at the NCLT. Specializing in Insolvency (IBC), shareholder disputes, and oppression & mismanagement.",
    helmetKeywords:
      "NCLT lawyer Delhi, National Company Law Tribunal, IBC 2016, corporate insolvency, oppression mismanagement, company law board",
    bannerImage:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The National Company Law Tribunal (NCLT) is the primary adjudicating authority for corporate disputes and insolvency proceedings in India. At Rai & Associates, we represent corporate debtors, financial creditors, operational creditors, and minority shareholders in high-stakes litigation before the Principal and Regional Benches of the NCLT, delivering aggressive and deadline-driven legal interventions.",
      sections: [
        {
          title: "Insolvency & Bankruptcy Code (IBC, 2016)",
          content:
            "We provide strategic representation for initiating or defending against the Corporate Insolvency Resolution Process (CIRP). Whether you are an operational creditor seeking to recover blocked funds, or a corporate promoter defending against a hostile insolvency petition, we meticulously navigate the strict timelines and thresholds of the IBC.",
        },
        {
          title: "Company Law & Internal Disputes",
          content:
            "Beyond insolvency, our chambers handle comprehensive corporate litigation under the Companies Act, 2013, including:",
          list: [
            "Oppression and Mismanagement Suits (Sec 241-242)",
            "Shareholder Rights and Joint Venture Disputes",
            "Mergers, Amalgamations, and Corporate Restructuring Schemes",
            "Removal of Director Disqualifications",
            "Restoration of Struck-off Companies by the ROC",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Defending Against CIRP",
        desc: "Successfully defended multiple MSMEs and corporate promoters against aggressive insolvency petitions by proving pre-existing disputes, saving the companies from liquidation.",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Protecting Minority Shareholders",
        desc: "Secured landmark interim orders restraining majority stakeholders from diluting the equity and operational control of minority directors in private limited companies.",
        img: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "nclat",
    icon: Banknote,
    title: "National Company Law Appellate Tribunal (NCLAT)",
    helmetTitle:
      "NCLAT Lawyers in Delhi | Corporate Appellate Litigation | Rai & Associates",
    helmetDescription:
      "Top-tier appellate representation before the NCLAT for appeals against NCLT, IBBI, and Competition Commission (CCI) orders.",
    helmetKeywords:
      "NCLAT lawyer Delhi, NCLAT appeal, IBC appellate tribunal, CCI appeal, corporate appellate litigation, challenge NCLT order",
    bannerImage:
      "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The National Company Law Appellate Tribunal (NCLAT) is the crucial appellate forum for challenging the orders of the NCLT, the Insolvency and Bankruptcy Board of India (IBBI), and the Competition Commission of India (CCI). Appellate litigation requires a vastly different skill set than original trials—demanding an unparalleled grasp of statutory interpretation and established jurisprudence. Rai & Associates excels in drafting and arguing complex corporate appeals.",
      sections: [
        {
          title: "Challenging Insolvency & Corporate Orders",
          content:
            "When an NCLT order jeopardizes your corporate existence or financial recovery, swift appellate action is mandatory. We specialize in obtaining urgent stays on CIRP admissions, challenging the approval of discriminatory Resolution Plans, and overturning erroneous rulings on oppression and mismanagement.",
        },
        {
          title: "Our Appellate Expertise",
          content:
            "We represent aggrieved parties in high-stakes appellate matters involving:",
          list: [
            "Appeals against CIRP Admission or Rejection Orders",
            "Challenging the actions of Resolution Professionals (RPs)",
            "Appeals against Competition Commission of India (CCI) penalty orders",
            "Defending Promoters against Fraudulent Trading charges (Sec 66 IBC)",
            "Briefing and leading Senior Advocates for complex Constitutional arguments",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Overturning CIRP Admissions",
        desc: "Successfully argued before the NCLAT to overturn the wrongful admission of a solvent company into insolvency, restoring the Board of Directors' control immediately.",
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Challenging Unfair Resolution Plans",
        desc: "Represented dissenting financial creditors to successfully challenge and modify a Committee of Creditors (CoC) approved resolution plan that unfairly prejudiced our clients.",
        img: "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "drt",
    icon: Receipt,
    title: "Debt Recovery Tribunal (DRT)",
    helmetTitle:
      "DRT Lawyers in Delhi | SARFAESI & NPA Defense | Rai & Associates",
    helmetDescription:
      "Aggressive legal defense against bank auctions and SARFAESI Act actions before the Debt Recovery Tribunal (DRT).",
    helmetKeywords:
      "DRT lawyer Delhi, SARFAESI Act defense, Securitization Application Sec 17, bank auction stay, NPA account lawyer, debt recovery tribunal",
    bannerImage:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "When an account is classified as a Non-Performing Asset (NPA), banks and NBFCs wield aggressive powers under the SARFAESI Act to seize and auction properties without court intervention. The Debt Recovery Tribunal (DRT) is the primary forum for borrowers to challenge these coercive actions. At Rai & Associates, we specialize in defending borrowers, corporate guarantors, and third-party property owners against arbitrary banking actions.",
      sections: [
        {
          title: "Halting SARFAESI Actions",
          content:
            "The moment a Section 13(2) or 13(4) notice is issued, the clock starts ticking on your property. We file robust Securitization Applications (SA) under Section 17 of the SARFAESI Act to expose the procedural irregularities of banks, with the primary objective of securing urgent stay orders to halt physical possession and asset auctions.",
        },
        {
          title: "Comprehensive DRT Litigation",
          content:
            "We offer specialized interventions in complex financial litigation at the DRT level:",
          list: [
            "Securing urgent stays on E-Auctions and Physical Possession",
            "Defending Original Applications (OA) filed by Banks for Debt Recovery",
            "Protecting Corporate Guarantors from Personal Asset Attachment",
            "Negotiating One-Time Settlements (OTS) with Financial Institutions",
            "Litigation against NBFCs and Asset Reconstruction Companies (ARCs)",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Halting Illegal Asset Auctions",
        desc: "Obtained urgent ex-parte stays from the DRT, halting the imminent auction of multi-crore industrial assets due to gross procedural violations by the lending bank in issuing the demand notice.",
        img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Protecting Guarantor Assets",
        desc: "Successfully shielded the personal residential properties of corporate directors from being attached by banks, proving technical flaws in the execution of the guarantees.",
        img: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "drat",
    icon: Globe,
    title: "Debt Recovery Appellate Tribunal (DRAT)",
    helmetTitle:
      "DRAT Lawyers in Delhi | Appellate Banking Litigation | Rai & Associates",
    helmetDescription:
      "Expert appellate representation at DRAT. Challenging DRT orders, navigating pre-deposit waivers, and securing stays on bank recoveries.",
    helmetKeywords:
      "DRAT lawyer Delhi, Debt Recovery Appellate Tribunal, DRAT appeal, SARFAESI appeal, pre-deposit waiver DRAT, challenge DRT order",
    bannerImage:
      "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Appeals against the orders of the Debt Recovery Tribunal (DRT) are heard by the Debt Recovery Appellate Tribunal (DRAT). Filing an appeal here is a highly technical and financially sensitive process, primarily due to the strict statutory requirement of a 'Pre-Deposit' (usually 25% to 50% of the debt amount) before an appeal can even be entertained. Rai & Associates provides tactical appellate representation to protect your commercial interests.",
      sections: [
        {
          title: "Navigating Pre-Deposits and Appellate Stays",
          content:
            "A poorly drafted appeal at the DRAT can result in the immediate dismissal of the case or crippling pre-deposit demands. We meticulously draft appeals focusing on pure questions of law and patent jurisdictional errors by the DRT, arguing forcefully for the maximum permissible waiver or reduction of the mandatory pre-deposit to ensure your appeal is heard on merits.",
        },
        {
          title: "Appellate DRAT Services",
          content: "Our appellate banking practice covers:",
          list: [
            "Appeals against final and interim orders of the DRT under the RDDBFI Act",
            "Appeals under Section 18 of the SARFAESI Act",
            "Arguing Applications for Waiver/Reduction of Pre-Deposit",
            "Challenging the confirmation of fraudulent Bank Auctions",
            "Filing Writ Petitions in the High Court against perverse DRAT orders",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Pre-Deposit Waivers",
        desc: "Successfully convinced the Appellate Tribunal to drastically reduce the mandatory pre-deposit amount for an MSME client, allowing them to legally challenge a highly inflated bank claim.",
        img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Restructuring NPA Debt",
        desc: "Successfully forced financial institutions to table viable One-Time Settlement (OTS) offers by legally stalling their coercive recovery mechanisms at the Appellate level.",
        img: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "trade-mark-matters-registrations",
    icon: ShoppingBag,
    title: "Trade Mark Matters & Registrations",
    helmetTitle:
      "Trademark Lawyers in Delhi | IP Registration & Litigation | Rai & Associates",
    helmetDescription:
      "Comprehensive Intellectual Property services. From trademark registration and objection replies to aggressive infringement and passing-off litigation.",
    helmetKeywords:
      "Trademark registration lawyer Delhi, trademark infringement, IP litigation, brand protection, passing off suit, trademark objection reply, IP attorney",
    bannerImage:
      "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Your brand's identity is often its most valuable commercial asset. Without robust legal protection, intellectual property is vulnerable to theft, dilution, and exploitation by competitors. Rai & Associates provides comprehensive, end-to-end Intellectual Property (IP) services—from securing your initial Trademark Registration to executing aggressive civil and criminal litigation against infringers.",
      sections: [
        {
          title: "Trademark Registry Prosecution",
          content:
            "A successful trademark is born from thorough research and precise filing. We handle the entire lifecycle of IP registration, protecting your brand from inception. Our services include conducting deep trademark searches, filing applications under the correct classes, drafting robust legal replies to Examination Reports, and representing clients in Show Cause hearings before the Trademark Registry.",
        },
        {
          title: "IP Infringement & Commercial Litigation",
          content:
            "When your brand is compromised, swift legal action is the only remedy. We act immediately in the Commercial Courts and High Courts to secure your intellectual property rights through:",
          list: [
            "Filing Commercial Suits for Trademark Infringement & Passing Off",
            "Securing Ex-Parte Interim Injunctions (Anton Piller & John Doe Orders)",
            "Drafting Cease and Desist Notices against Counterfeiters",
            "Opposing Malicious Trademark Applications filed by Competitors",
            "Domain Name Disputes and Cyber-Squatting Litigation",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Securing Brand Monopolies",
        desc: "Successfully overcame complex Registry objections (Section 9 & Section 11) to secure absolute trademark registrations for highly contested brand names in the FMCG and tech sectors.",
        img: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Enforcing Anti-Counterfeit Injunctions",
        desc: "Secured swift Anton Piller orders from the High Court, leading to the court-appointed raid and seizure of counterfeit goods that were heavily diluting our client's premium brand equity.",
        img: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "dcrdc",
    icon: ClipboardList,
    title: "District Consumer Disputes Redressal Commission (DCDRC)",
    helmetTitle:
      "District Consumer Court Lawyers in Delhi | DCDRC | Rai & Associates",
    helmetDescription:
      "Aggressive legal representation at the District Consumer Forum (DCDRC) for insurance rejections, medical negligence, and service deficiencies.",
    helmetKeywords:
      "DCDRC lawyer Delhi, district consumer forum advocate, consumer court lawyer, insurance claim rejection, deficiency in service, unfair trade practice",
    bannerImage:
      "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The District Consumer Disputes Redressal Commission (DCDRC) is the crucial first step for consumers seeking justice against corporate exploitation, defective goods, and deficient services for claims up to ₹50 Lakhs. At Rai & Associates, we understand that fighting large corporations and insurance companies can be intimidating for an individual. Our chambers provide aggressive, evidence-backed representation to level the playing field and secure swift compensation for our clients.",
      sections: [
        {
          title: "Holding Corporations Accountable",
          content:
            "We bypass standard customer service delays by initiating direct, hard-hitting litigation. Whether a bank has levied hidden charges, a local hospital has shown negligence, or an e-commerce giant has engaged in unfair trade practices, we ensure your grievances are met with strict judicial orders.",
        },
        {
          title: "Our DCDRC Litigation Services",
          content:
            "We regularly represent consumers and small businesses in matters concerning:",
          list: [
            "Arbitrary Rejection of Health, Motor, and Life Insurance Claims",
            "Medical Negligence by Local Clinics and Nursing Homes",
            "Deficiency in Banking, Aviation, and Telecom Services",
            "Unfair Trade Practices and Misleading Advertisements",
            "Execution of Consumer Court Orders to enforce immediate payment",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Overturning Insurance Rejections",
        desc: "Successfully represented policyholders against major health insurance aggregators, compelling them to clear arbitrarily rejected cashless claims along with penal interest.",
        img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Banking Deficiency Recoveries",
        desc: "Secured compensation and full refunds for clients who suffered financial losses due to unauthorized banking transactions and systemic technical failures.",
        img: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "scdrc",
    icon: ScrollText,
    title: "State Consumer Disputes Redressal Commission (SCDRC)",
    helmetTitle:
      "SCDRC Lawyers in Delhi | State Consumer Commission | Rai & Associates",
    helmetDescription:
      "Expert appellate and original jurisdiction representation at the State Consumer Commission (SCDRC) for high-value consumer disputes.",
    helmetKeywords:
      "SCDRC lawyer Delhi, State Consumer Commission advocate, consumer appeal lawyer, real estate consumer case, high value medical negligence",
    bannerImage:
      "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The State Consumer Disputes Redressal Commission (SCDRC) exercises both original jurisdiction (for high-value claims between ₹50 Lakhs and ₹2 Crores) and crucial appellate jurisdiction over all District Forums within the state. Litigation at this level involves complex fact-finding, expert testimonies, and rigorous statutory interpretation. Rai & Associates fields a dedicated team of consumer appellate lawyers to protect your high-stakes commercial and personal interests.",
      sections: [
        {
          title: "Navigating High-Value Disputes & Appeals",
          content:
            "If a District Forum passes an adverse or inadequate compensation order, the SCDRC is the immediate appellate remedy. Conversely, for significant real estate delays or major medical malpractice resulting in severe injury or death, we file directly before the SCDRC to secure appropriate, multi-crore compensation.",
        },
        {
          title: "SCDRC Practice Areas",
          content:
            "We handle complex, high-value consumer litigation including:",
          list: [
            "Statutory Appeals challenging adverse DCDRC judgments",
            "Real Estate Disputes (Delayed possession of premium flats)",
            "High-Value Medical Negligence against Corporate Hospitals",
            "Commercial Insurance Disputes (Fire, Marine, & Factory Insurance)",
            "Defending Doctors and Service Providers against frivolous appeals",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Real Estate Delayed Possession",
        desc: "Secured stringent orders from the State Commission against tier-1 builders, resulting in the handover of premium apartments along with 9% delay penalty interest.",
        img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Enhancement of Compensation",
        desc: "Successfully appealed inadequate District Forum orders, convincing the State Commission to drastically enhance the compensation awarded to victims of severe medical negligence.",
        img: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "ncdrc",
    icon: Briefcase,
    title: "National Consumer Disputes Redressal Commission (NCDRC)",
    helmetTitle:
      "NCDRC Lawyers in New Delhi | Apex Consumer Court | Rai & Associates",
    helmetDescription:
      "Top-tier representation at the Apex NCDRC for claims exceeding ₹2 Crores, class-action suits, and critical revision petitions.",
    helmetKeywords:
      "NCDRC lawyer Delhi, National Consumer Commission, class action consumer suit, revision petition NCDRC, apex consumer court advocate",
    bannerImage:
      "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The National Consumer Disputes Redressal Commission (NCDRC) is the apex consumer court in India, situated in New Delhi. It holds original jurisdiction for massive claims exceeding ₹2 Crores, alongside sweeping appellate and revisional powers over all State Commissions. Practice at the NCDRC demands the highest caliber of legal strategy, akin to Supreme Court litigation. Rai & Associates is highly sought after for leading complex, multi-party consumer battles at the National Commission.",
      sections: [
        {
          title: "Class Action & Apex Appellate Litigation",
          content:
            "When corporations employ top-tier legal defense teams to deny rightful claims, we level the battlefield. We specialize in aggregating the claims of numerous aggrieved consumers (Class Action Suits) to mount overwhelming legal pressure against defaulting real estate developers and multinational service providers.",
        },
        {
          title: "Our Apex Consumer Practice",
          content:
            "Our NCDRC representation encompasses the most critical consumer matters:",
          list: [
            "Class Action Suits under Section 35(1)(c) for Homebuyers' Associations",
            "Original Complaints for High-Net-Worth claims (> ₹2 Crores)",
            "First Appeals against final orders of any State Commission",
            "Revision Petitions challenging jurisdictional errors by State Commissions",
            "Execution Petitions to attach corporate assets of non-compliant entities",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Homebuyers' Class Action Success",
        desc: "Spearheaded a massive class-action suit at the NCDRC representing over 100 aggrieved homebuyers, ultimately forcing a bankrupt developer into a court-monitored settlement.",
        img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Landmark Medical Negligence Awards",
        desc: "Successfully argued complex revision petitions to secure multi-crore compensation awards for families affected by gross procedural negligence at tier-1 corporate hospitals.",
        img: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "district-consumer-forum-dcdrc",
    icon: ClipboardList,
    title: "District Consumer Disputes Redressal Commission (DCDRC)",
    helmetTitle:
      "District Consumer Court Lawyers in Delhi | DCDRC | Rai & Associates",
    helmetDescription:
      "Aggressive legal representation at the District Consumer Forum (DCDRC) for insurance rejections, medical negligence, and service deficiencies.",
    helmetKeywords:
      "DCDRC lawyer Delhi, district consumer forum advocate, consumer court lawyer, insurance claim rejection, deficiency in service, unfair trade practice",
    bannerImage:
      "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The District Consumer Disputes Redressal Commission (DCDRC) is the crucial first step for consumers seeking justice against corporate exploitation, defective goods, and deficient services for claims up to ₹50 Lakhs. At Rai & Associates, we understand that fighting large corporations and insurance companies can be intimidating for an individual. Our chambers provide aggressive, evidence-backed representation to level the playing field and secure swift compensation for our clients.",
      sections: [
        {
          title: "Holding Corporations Accountable",
          content:
            "We bypass standard customer service delays by initiating direct, hard-hitting litigation. Whether a bank has levied hidden charges, a local hospital has shown negligence, or an e-commerce giant has engaged in unfair trade practices, we ensure your grievances are met with strict judicial orders.",
        },
        {
          title: "Our DCDRC Litigation Services",
          content:
            "We regularly represent consumers and small businesses in matters concerning:",
          list: [
            "Arbitrary Rejection of Health, Motor, and Life Insurance Claims",
            "Medical Negligence by Local Clinics and Nursing Homes",
            "Deficiency in Banking, Aviation, and Telecom Services",
            "Unfair Trade Practices and Misleading Advertisements",
            "Execution of Consumer Court Orders to enforce immediate payment",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Overturning Insurance Rejections",
        desc: "Successfully represented policyholders against major health insurance aggregators, compelling them to clear arbitrarily rejected cashless claims along with penal interest.",
        img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Banking Deficiency Recoveries",
        desc: "Secured compensation and full refunds for clients who suffered financial losses due to unauthorized banking transactions and systemic technical failures.",
        img: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "state-consumer-commission-scdrc",
    icon: ScrollText,
    title: "State Consumer Disputes Redressal Commission (SCDRC)",
    helmetTitle:
      "SCDRC Lawyers in Delhi | State Consumer Commission | Rai & Associates",
    helmetDescription:
      "Expert appellate and original jurisdiction representation at the State Consumer Commission (SCDRC) for high-value consumer disputes.",
    helmetKeywords:
      "SCDRC lawyer Delhi, State Consumer Commission advocate, consumer appeal lawyer, real estate consumer case, high value medical negligence",
    bannerImage:
      "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The State Consumer Disputes Redressal Commission (SCDRC) exercises both original jurisdiction (for high-value claims between ₹50 Lakhs and ₹2 Crores) and crucial appellate jurisdiction over all District Forums within the state. Litigation at this level involves complex fact-finding, expert testimonies, and rigorous statutory interpretation. Rai & Associates fields a dedicated team of consumer appellate lawyers to protect your high-stakes commercial and personal interests.",
      sections: [
        {
          title: "Navigating High-Value Disputes & Appeals",
          content:
            "If a District Forum passes an adverse or inadequate compensation order, the SCDRC is the immediate appellate remedy. Conversely, for significant real estate delays or major medical malpractice resulting in severe injury or death, we file directly before the SCDRC to secure appropriate, multi-crore compensation.",
        },
        {
          title: "SCDRC Practice Areas",
          content:
            "We handle complex, high-value consumer litigation including:",
          list: [
            "Statutory Appeals challenging adverse DCDRC judgments",
            "Real Estate Disputes (Delayed possession of premium flats)",
            "High-Value Medical Negligence against Corporate Hospitals",
            "Commercial Insurance Disputes (Fire, Marine, & Factory Insurance)",
            "Defending Doctors and Service Providers against frivolous appeals",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Real Estate Delayed Possession",
        desc: "Secured stringent orders from the State Commission against tier-1 builders, resulting in the handover of premium apartments along with 9% delay penalty interest.",
        img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Enhancement of Compensation",
        desc: "Successfully appealed inadequate District Forum orders, convincing the State Commission to drastically enhance the compensation awarded to victims of severe medical negligence.",
        img: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "national-consumer-commission-ncdrc",
    icon: Briefcase,
    title: "National Consumer Disputes Redressal Commission (NCDRC)",
    helmetTitle:
      "NCDRC Lawyers in New Delhi | Apex Consumer Court | Rai & Associates",
    helmetDescription:
      "Top-tier representation at the Apex NCDRC for claims exceeding ₹2 Crores, class-action suits, and critical revision petitions.",
    helmetKeywords:
      "NCDRC lawyer Delhi, National Consumer Commission, class action consumer suit, revision petition NCDRC, apex consumer court advocate",
    bannerImage:
      "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The National Consumer Disputes Redressal Commission (NCDRC) is the apex consumer court in India, situated in New Delhi. It holds original jurisdiction for massive claims exceeding ₹2 Crores, alongside sweeping appellate and revisional powers over all State Commissions. Practice at the NCDRC demands the highest caliber of legal strategy, akin to Supreme Court litigation. Rai & Associates is highly sought after for leading complex, multi-party consumer battles at the National Commission.",
      sections: [
        {
          title: "Class Action & Apex Appellate Litigation",
          content:
            "When corporations employ top-tier legal defense teams to deny rightful claims, we level the battlefield. We specialize in aggregating the claims of numerous aggrieved consumers (Class Action Suits) to mount overwhelming legal pressure against defaulting real estate developers and multinational service providers.",
        },
        {
          title: "Our Apex Consumer Practice",
          content:
            "Our NCDRC representation encompasses the most critical consumer matters:",
          list: [
            "Class Action Suits under Section 35(1)(c) for Homebuyers' Associations",
            "Original Complaints for High-Net-Worth claims (> ₹2 Crores)",
            "First Appeals against final orders of any State Commission",
            "Revision Petitions challenging jurisdictional errors by State Commissions",
            "Execution Petitions to attach corporate assets of non-compliant entities",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Homebuyers' Class Action Success",
        desc: "Spearheaded a massive class-action suit at the NCDRC representing over 100 aggrieved homebuyers, ultimately forcing a bankrupt developer into a court-monitored settlement.",
        img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Landmark Medical Negligence Awards",
        desc: "Successfully argued complex revision petitions to secure multi-crore compensation awards for families affected by gross procedural negligence at tier-1 corporate hospitals.",
        img: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "rera",
    icon: Laptop, // ✅ FIXED — was broken as `icon: ,`
    title: "RERA Litigation & Compliance",
    helmetTitle:
      "RERA Lawyers in Delhi | Real Estate Litigation | Rai & Associates",
    helmetDescription:
      "Expert RERA lawyers for homebuyers and developers. Specializing in delayed possession, builder-buyer disputes, and REAT appeals.",
    helmetKeywords:
      "RERA lawyer Delhi, Real Estate Regulatory Authority, builder delay compensation, RERA appeal REAT, homebuyer rights, builder-buyer agreement",
    bannerImage:
      "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The Real Estate (Regulation and Development) Act (RERA) transformed the Indian real estate landscape, providing a specialized forum to hold defaulting developers accountable. At Rai & Associates, we represent both aggrieved homebuyers seeking swift justice and legitimate real estate promoters requiring complex compliance defense. Our chambers actively litigate before the State RERA Authorities, Adjudicating Officers, and the Real Estate Appellate Tribunal (REAT).",
      sections: [
        {
          title: "Aggressive Homebuyer Representation",
          content:
            "We bypass endless builder negotiations and directly invoke RERA jurisdiction to secure immediate refunds, delayed possession interest, and structural defect compensation. We aggressively pursue the execution of RERA recovery certificates through the District Magistrate to attach builder assets.",
        },
        {
          title: "Comprehensive RERA Services",
          content: "Our real estate litigation practice covers:",
          list: [
            "Filing Complaints for Delayed Possession and Refunds (Sec 18)",
            "Challenging One-Sided Builder-Buyer Agreements",
            "Filing Appeals before the Real Estate Appellate Tribunal (REAT)",
            "Defending Developers against frivolous/extortionate allottee claims",
            "Execution Petitions to enforce RERA orders and attach builder accounts",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Enforcing Refund Execution",
        desc: "Successfully forced the execution of multi-crore RERA refund orders by compelling authorities to seal the commercial offices and freeze bank accounts of defaulting tier-1 developers.",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Project Deregistration Defense",
        desc: "Defended prominent real estate promoters before the RERA Authority, successfully preventing the arbitrary deregistration of their ongoing housing projects.",
        img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "cyber-crime",
    icon: Laptop,
    title: "Cyber Crime & IT Act",
    helmetTitle:
      "Cyber Crime Lawyers in Delhi | IT Act Defense | Rai & Associates",
    helmetDescription:
      "Specialized legal defense for cyber crimes, financial fraud, data theft, and online defamation under the Information Technology (IT) Act.",
    helmetKeywords:
      "Cyber crime lawyer Delhi, IT Act 2000, data theft lawyer, online financial fraud, cyber defamation, crypto fraud lawyer, cyber cell complaint",
    bannerImage:
      "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "As businesses and personal lives transition online, cyber crime has become one of the most complex areas of criminal jurisprudence. Rai & Associates provides cutting-edge legal representation for victims of sophisticated digital fraud, as well as aggressive defense for individuals and tech directors falsely implicated under the Information Technology (IT) Act. We routinely liaise with specialized Cyber Cells and litigate in specialized cyber courts.",
      sections: [
        {
          title: "Navigating Digital Forensics",
          content:
            "Cyber litigation is won on electronic evidence. We collaborate with digital forensics experts to trace IP logs, secure Section 65B Evidence Act certificates, track cryptocurrency trails, and unmask anonymous perpetrators. Conversely, we dismantle prosecution cases by exposing the illegal seizure of digital devices and compromised hash values.",
        },
        {
          title: "Our Cyber Law Expertise",
          content: "We handle high-stakes digital litigation including:",
          list: [
            "Corporate Data Theft and Source Code Piracy (Sec 43 & 66 IT Act)",
            "Online Financial Fraud, Phishing, and Crypto Scams",
            "Cyber Defamation, Stalking, and Revenge Porn (Sec 67 IT Act)",
            "Unfreezing Bank Accounts blocked by Cyber Cell/Police",
            "Defending IT Directors & Intermediaries (Safe Harbour protections)",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Unfreezing Commercial Accounts",
        desc: "Successfully approached the High Court to unblock corporate bank accounts that were arbitrarily frozen by cyber police during a pan-India cryptocurrency investigation.",
        img: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Corporate Data Theft Recovery",
        desc: "Secured immediate Anton Piller injunctions against former employees, resulting in the confiscation of devices containing stolen proprietary source code and client databases.",
        img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "ndps",
    icon: Pill,
    title: "NDPS Act Defense",
    helmetTitle:
      "NDPS Lawyers in Delhi | Narcotics Criminal Defense | Rai & Associates",
    helmetDescription:
      "Elite criminal defense for drug offences under the NDPS Act. Expertise in securing bail and exposing illegal search and seizure procedures.",
    helmetKeywords:
      "NDPS lawyer Delhi, Narcotics drug lawyer, NDPS bail, Section 37 NDPS, commercial quantity drug case, illegal search and seizure defense",
    bannerImage:
      "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The Narcotic Drugs and Psychotropic Substances (NDPS) Act is one of the most draconian statutes in Indian law. Cases involving 'commercial quantities' invoke the rigorous twin conditions of Section 37, making bail exceptionally difficult and the presumption of guilt heavily skewed against the accused. Rai & Associates provides an elite, highly technical defense strategy to challenge narcotics agencies (NCB, Special Cell) from the moment of arrest through trial.",
      sections: [
        {
          title: "Dismantling the Investigation",
          content:
            "NDPS trials are entirely procedural. A single violation by the investigating agency—such as failing to comply with Section 50 (right to be searched before a Magistrate) or Section 42 (recording information)—can vitiate the entire trial. Our primary strategy focuses on exposing these fatal procedural lapses to secure acquittals and statutory bail.",
        },
        {
          title: "Critical NDPS Trial Interventions",
          content: "We handle the most serious narcotics prosecutions:",
          list: [
            "Securing Bail in Commercial Quantity cases by breaking Section 37 rigors",
            "Challenging illegal Search, Seizure, and Sampling protocols",
            "Defending against allegations of Drug Financing and Conspiracy (Sec 27A & 29)",
            "Cross-examining forensic analysts regarding CRCL testing delays",
            "Quashing of NDPS proceedings in the High Court",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Breaking Section 37 Bail Rigors",
        desc: "Successfully secured bail from the High Court in a multi-kilo commercial quantity case by proving fatal discrepancies in the NCB's sampling and seizure memo.",
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Acquittal via Procedural Lapses",
        desc: "Secured a complete trial acquittal for a client by rigorously cross-examining the arresting officers and proving absolute non-compliance with Section 50 of the NDPS Act.",
        img: "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "tender-litigation",
    icon: AlertTriangle,
    title: "Tender Litigation & Government Contracts",
    helmetTitle:
      "Tender Litigation Lawyers in Delhi High Court | Rai & Associates",
    helmetDescription:
      "Strategic legal intervention in government tender disputes. Specializing in writ petitions against arbitrary rejection and blacklisting.",
    helmetKeywords:
      "Tender lawyer Delhi, government contract dispute, writ of mandamus, arbitrary tender rejection, blacklisting lawyer, PSU tender dispute",
    bannerImage:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "Bidding for high-value government and Public Sector Undertaking (PSU) contracts is a highly competitive and highly regulated process. When a tender is arbitrarily rejected, or a contract is wrongfully terminated due to bureaucratic bias or malice, immediate judicial intervention is required. Rai & Associates invokes the extraordinary writ jurisdiction of the High Courts to halt unfair tender processes and protect the commercial rights of corporate bidders.",
      sections: [
        {
          title: "Challenging Arbitrary State Action",
          content:
            "While courts generally do not interfere in administrative decisions, they will strike down a tender process if it is marred by arbitrariness, favoritism, or a violation of natural justice (Article 14). We move swiftly to secure stay orders against the awarding of contracts to ineligible rival bidders.",
        },
        {
          title: "Tender & Contractual Remedies",
          content:
            "We represent contractors, infrastructure firms, and tech vendors in:",
          list: [
            "Filing Writ Petitions against Arbitrary Disqualification of Bids",
            "Securing Stays on the Encasement of Bank Guarantees (Injunctions)",
            "Challenging arbitrary 'Blacklisting' or Debarment orders by the State",
            "Litigating Breach of Government Contracts and Price Escalation claims",
            "Invoking Arbitration clauses in specific PSU disputes",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Quashing Tender Favoritism",
        desc: "Successfully obtained a High Court writ striking down a multi-crore municipal tender award, proving that the tender conditions were maliciously tailored to favor a specific rival bidder.",
        img: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Revoking Corporate Blacklisting",
        desc: "Secured immediate interim relief staying a PSU's arbitrary blacklisting order, thereby allowing our infrastructure client to continue bidding for national highway projects.",
        img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "white-collar-crime",
    icon: Gavel,
    title: "White Collar Crime Defense",
    helmetTitle:
      "White Collar Crime Lawyers in Delhi | Corporate Fraud Defense",
    helmetDescription:
      "Elite criminal defense for corporate fraud, cheating, forgery, and financial misappropriation by directors and promoters.",
    helmetKeywords:
      "White collar crime lawyer Delhi, corporate fraud defense, Section 420 IPC, SFIO investigation lawyer, embezzlement, corporate criminal liability",
    bannerImage:
      "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "White-collar crimes—such as corporate fraud, embezzlement, and complex financial cheating—require a defense strategy that is as sophisticated as the allegations themselves. The line between a genuine business failure and criminal intent (Mens Rea) is often blurred by aggressive investigating agencies and hostile investors. Rai & Associates provides high-level defense for Managing Directors, Promoters, and corporate entities facing severe financial prosecutions.",
      sections: [
        {
          title: "Pre-Emptive Strategy and Trial Defense",
          content:
            "Our defense strategy focuses heavily on financial auditing and documentary evidence. We specialize in demonstrating that alleged 'frauds' are, in reality, civil breaches of contract, thereby pushing courts to grant bail and quash criminal proceedings. We manage parallel investigations by local police, the SFIO, and tax authorities.",
        },
        {
          title: "Scope of White Collar Defense",
          content:
            "We protect the liberty and reputation of corporate executives facing allegations of:",
          list: [
            "Cheating, Forgery, and Criminal Breach of Trust (Sec 420, 468, 406)",
            "Corporate Fraud Investigations by SFIO (Serious Fraud Investigation Office)",
            "Misappropriation of Company Funds & Embezzlement",
            "Defending Corporate Criminal Liability (Directors' Liability)",
            "Quashing of FIRs arising out of purely civil/commercial disputes",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Quashing Civil-Turned-Criminal Cases",
        desc: "Successfully approached the High Court to quash Section 420 (Cheating) FIRs against a tech CEO, proving the complainant maliciously criminalized a standard vendor dispute.",
        img: "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Anticipatory Bail for Promoters",
        desc: "Secured pre-arrest bail from the Supreme Court for real estate promoters facing massive multi-state FIRs regarding alleged corporate fund diversion.",
        img: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "juvenile-matter",
    icon: BookOpen,
    title: "Juvenile Matters (JJ Act)",
    helmetTitle:
      "Juvenile Justice Lawyers in Delhi | JJ Act Defense | Rai & Associates",
    helmetDescription:
      "Sensitive and highly confidential legal representation for children in conflict with the law under the Juvenile Justice Act.",
    helmetKeywords:
      "Juvenile justice lawyer Delhi, JJ Act advocate, child in conflict with law, juvenile bail lawyer, heinous crime juvenile trial, JJB lawyer",
    bannerImage:
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "When a minor is accused of a crime, the legal approach must shift entirely from 'punishment' to 'rehabilitation'. The Juvenile Justice (Care and Protection of Children) Act provides special protections, strict confidentiality, and mandatory bail provisions for children in conflict with the law. Rai & Associates provides deeply empathetic, yet fiercely protective legal counsel before the Juvenile Justice Board (JJB) to safeguard the child's future and prevent lifelong stigma.",
      sections: [
        {
          title: "Preventing Trial as an Adult",
          content:
            "A critical battleground in juvenile law occurs when a minor (aged 16-18) is accused of a 'heinous' offence (e.g., murder or rape). The JJB conducts a preliminary assessment to decide if the child should be transferred to a Children's Court to be tried as an adult. We work closely with child psychologists and aggressively challenge these assessments to ensure the minor retains the protective cover of the JJ Act.",
        },
        {
          title: "Our Juvenile Defense Services",
          content:
            "We ensure absolute confidentiality and swift intervention regarding:",
          list: [
            "Securing Immediate Bail/Release from Observation Homes",
            "Challenging Preliminary Assessments (preventing adult trials)",
            "Ensuring Expungement of Records to protect future employment/visas",
            "Representing minors in inquiries before the Juvenile Justice Board",
            "Filing appeals before the Children's Court and High Court",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Preventing Adult Prosecution",
        desc: "Successfully appealed a JJB order, preventing a 17-year-old accused of a heinous crime from being tried as an adult by proving severe developmental and psychological immaturity.",
        img: "https://images.unsplash.com/photo-1633526543814-9718c8922b7a?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Securing Mandatory Bail",
        desc: "Secured the immediate release of a minor from an observation home, compelling the Board to adhere to the strict statutory bail mandate under Section 12 of the JJ Act.",
        img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "arbitration-conciliation-odr",
    icon: TrendingDown,
    title: "Arbitration, Conciliation & ODR",
    helmetTitle: "Arbitration Lawyers in Delhi | Commercial Dispute Resolution",
    helmetDescription:
      "Expert representation in domestic and international commercial arbitration. Specializing in Section 9 injunctions and Section 34 appeals.",
    helmetKeywords:
      "Arbitration lawyer Delhi, commercial arbitration, Section 9 injunction, Section 34 appeal, arbitral award execution, conciliation lawyer, ODR",
    bannerImage:
      "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "In high-stakes corporate and commercial disputes, prolonged court battles can destroy business value. Arbitration, Conciliation, and Online Dispute Resolution (ODR) provide a private, specialized, and rapid mechanism to resolve complex contractual conflicts. Rai & Associates fields a dedicated Alternative Dispute Resolution (ADR) team, representing multinational corporations, MSMEs, and infrastructure firms in ad-hoc and institutional arbitrations.",
      sections: [
        {
          title: "Aggressive Arbitration Strategy",
          content:
            "An arbitration is only effective if the underlying assets are secured. We frequently approach the Commercial Courts/High Courts under Section 9 of the Arbitration Act to secure urgent pre-arbitration injunctions, freezing respondent assets or halting the encashment of bank guarantees before the tribunal is even constituted.",
        },
        {
          title: "Comprehensive ADR Practice",
          content:
            "Our arbitration practice encompasses the entire lifecycle of a dispute:",
          list: [
            "Securing Interim Reliefs from Courts (Section 9) and Tribunals (Section 17)",
            "Appointment of Arbitrators via the High Court/Supreme Court (Section 11)",
            "Drafting Claims, Conducting Cross-Examinations, and Final Arguments",
            "Challenging Arbitral Awards in Court (Section 34)",
            "Execution and Enforcement of Domestic and Foreign Arbitral Awards",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Securing Pre-Arbitration Injunctions",
        desc: "Obtained a critical Section 9 injunction from the High Court, preventing a PSU from illegally invoking a ₹50 Crore bank guarantee while arbitration was pending.",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Enforcing Arbitral Awards",
        desc: "Successfully navigated complex execution proceedings to attach the commercial real estate assets of a defaulting judgment debtor, ensuring actual recovery for our client.",
        img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "eow",
    icon: HandCoins,
    title: "EOW (Economic Offences Wing)",
    helmetTitle:
      "EOW Defense Lawyers in Delhi | Economic Offences Investigation",
    helmetDescription:
      "Strategic criminal defense for high-profile EOW investigations involving multi-victim frauds, Ponzi schemes, and builder cheating cases.",
    helmetKeywords:
      "EOW lawyer Delhi, Economic Offences Wing, multi victim fraud, builder fraud defense, Ponzi scheme lawyer, EOW anticipatory bail",
    bannerImage:
      "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The Economic Offences Wing (EOW) is a specialized police agency tasked with investigating complex, large-scale financial crimes, multi-victim frauds, and massive corporate cheating cases. EOW investigations are notoriously aggressive, often involving multiple FIRs, look-out circulars (LOCs), and imminent threats of arrest for corporate directors. Rai & Associates provides high-level crisis management and criminal defense for executives and promoters facing EOW scrutiny.",
      sections: [
        {
          title: "Navigating High-Stakes Financial Probes",
          content:
            "EOW cases (typically involving amounts over ₹3 Crores or massive public involvement) require a defense that combines acute financial auditing with aggressive criminal litigation. We intervene early during the inquiry stage, responding to notices under Section 41A CrPC (now Section 35 BNSS), and strategize to secure pre-arrest protection from the courts.",
        },
        {
          title: "EOW Defense Capabilities",
          content:
            "We represent clients in highly complex economic investigations, including:",
          list: [
            "Real Estate & Builder Frauds (Multiple Homebuyer FIRs)",
            "Ponzi Schemes, Chit Fund Frauds, and Multi-Level Marketing (MLM) cases",
            "Bank Frauds, Loan Defaults, and Siphoning of Funds",
            "Securing Anticipatory Bail and Quashing Look-Out Circulars (LOCs)",
            "Defending Corporate Promoters against mass-cheating allegations",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Halting Look-Out Circulars",
        desc: "Successfully petitioned the High Court to quash an arbitrary Look-Out Circular (LOC) issued by the EOW, allowing an NRI director to travel internationally for business.",
        img: "https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Consolidating EOW FIRs",
        desc: "Approached the Supreme Court to consolidate hundreds of individual investor FIRs spread across multiple states into a single EOW investigation, streamlining the defense and securing bail.",
        img: "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "ed",
    icon: Fingerprint,
    title: "ED (Enforcement Directorate) Matters",
    helmetTitle: "ED Investigation Lawyers in Delhi | FEMA & Asset Attachment",
    helmetDescription:
      "Elite legal defense against Enforcement Directorate (ED) summons, FEMA violations, and provisional attachment of properties.",
    helmetKeywords:
      "ED lawyer Delhi, Enforcement Directorate advocate, FEMA violation, ED summons reply, attachment of property ED, foreign exchange management",
    bannerImage:
      "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The Enforcement Directorate (ED) wields extraordinary powers of search, seizure, and arrest, tasked primarily with investigating economic intelligence, foreign exchange violations (FEMA), and money laundering. An ED summons or a raid can instantly paralyze a business and damage a promoter's reputation. Rai & Associates provides elite, highly confidential counsel to navigate aggressive ED probes, protecting corporate and personal assets from arbitrary state action.",
      sections: [
        {
          title: "Handling ED Summons and FEMA Probes",
          content:
            "Receiving a summons from the ED requires a meticulous, legally vetted response. Information provided during ED interrogations is admissible as evidence. We prepare our clients for these high-pressure inquiries, ensuring compliance with the Foreign Exchange Management Act (FEMA) while strictly protecting their constitutional right against self-incrimination.",
        },
        {
          title: "Our ED Defense Interventions",
          content:
            "We provide comprehensive defense against the Directorate's actions:",
          list: [
            "Advising and representing clients responding to ED Summons",
            "Challenging Provisional Attachment Orders (PAO) before the Adjudicating Authority",
            "Appeals before the Appellate Tribunal for SAFEMA, FEMA, & PMLA",
            "Defending against allegations of Hawala transactions and FEMA contraventions",
            "Securing release of illegally seized passports and corporate documents",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Lifting Provisional Attachments",
        desc: "Successfully challenged a Provisional Attachment Order (PAO) before the Adjudicating Authority, releasing a corporate client's frozen bank accounts critical to their business operations.",
        img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Navigating FEMA Probes",
        desc: "Guided an export-import firm through a massive ED investigation regarding alleged foreign exchange violations, successfully resolving the matter without any criminal prosecution.",
        img: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "cbi",
    icon: BadgeAlert,
    title: "CBI (Central Bureau of Investigation)",
    helmetTitle: "CBI Defense Lawyers in Delhi | PC Act & High Profile Frauds",
    helmetDescription:
      "Top-tier criminal defense for CBI investigations. Specializing in Prevention of Corruption Act (PC Act), trap cases, and bank frauds.",
    helmetKeywords:
      "CBI lawyer Delhi, Central Bureau of Investigation, PC Act lawyer, corruption case defense, trap case CBI, disproportionate assets lawyer",
    bannerImage:
      "https://images.unsplash.com/photo-1505664194779-8beaceb93744?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The Central Bureau of Investigation (CBI) is India's premier investigating agency, handling the nation's most high-profile anti-corruption cases, massive economic offences, and complex interstate crimes. A CBI prosecution carries intense media scrutiny and severe legal consequences. Rai & Associates fields a formidable team of trial lawyers experienced in defending civil servants, politicians, and corporate directors in Special CBI Courts.",
      sections: [
        {
          title: "Anti-Corruption & PC Act Defense",
          content:
            "Cases under the Prevention of Corruption (PC) Act—such as 'trap' cases, demand for illegal gratification, and disproportionate assets—rely heavily on technical voice forensics, sanction orders, and chain of custody. We rigorously dismantle the CBI's evidence, exposing procedural flaws in the laying of traps and the calculation of assets.",
        },
        {
          title: "CBI Litigation Services",
          content: "We handle the most critical phases of a CBI prosecution:",
          list: [
            "Defense against PC Act charges (Bribes, Trap Cases, Disproportionate Assets)",
            "Defending Promoters in massive Bank Frauds and Consortium Loan Defaults",
            "Challenging the 'Sanction for Prosecution' of Public Servants",
            "Securing Regular and Anticipatory Bail from Special CBI Courts",
            "Quashing CBI FIRs in the High Court based on jurisdictional errors",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Acquittal in PC Act Trap Cases",
        desc: "Secured a complete acquittal for a senior bureaucrat in a CBI trap case by forensically proving that the 'demand and acceptance' of the bribe was fabricated by the complainant.",
        img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Defending Massive Bank Frauds",
        desc: "Successfully secured anticipatory bail for the directors of a manufacturing firm facing a ₹500 Crore CBI bank fraud investigation, proving the default was a genuine business failure.",
        img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "pmla",
    icon: CircleDollarSign,
    title: "PMLA (Prevention of Money Laundering Act)",
    helmetTitle:
      "PMLA Lawyers in Delhi | Money Laundering Defense | Rai & Associates",
    helmetDescription:
      "Elite defense against PMLA prosecutions. Specializing in breaking the strict Section 45 bail rigors and un-attaching seized assets.",
    helmetKeywords:
      "PMLA lawyer Delhi, Prevention of Money laundering act, ECIR quashing, PMLA bail lawyer, Section 45 PMLA, proceeds of crime defense",
    bannerImage:
      "https://images.unsplash.com/photo-1478860409698-8707f313ee8b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "The Prevention of Money Laundering Act (PMLA) is arguably the most stringent economic criminal statute in India. It empowers authorities to arrest individuals, attach properties, and freeze accounts simply on the suspicion that they represent 'proceeds of crime'. The twin conditions for bail under Section 45 of the PMLA make pre-trial release exceptionally difficult. Rai & Associates delivers highly aggressive, constitutionally grounded litigation to fight PMLA charges.",
      sections: [
        {
          title: "Dismantling the ECIR & Proceeds of Crime",
          content:
            "A PMLA case cannot exist in isolation; it must stem from a 'Scheduled Offence' (e.g., a CBI or EOW FIR). Our dual-pronged strategy involves simultaneously attacking the underlying scheduled offence while challenging the Enforcement Directorate's ECIR. If we can prove that the assets in question are untainted by the alleged crime, the foundation of the PMLA prosecution collapses.",
        },
        {
          title: "Strategic PMLA Defense",
          content:
            "We provide uncompromising defense in the most complex money laundering probes:",
          list: [
            "Overcoming Section 45 Rigors to Secure Regular & Anticipatory Bail",
            "Quashing of the ECIR based on the acquittal in the Scheduled Offence",
            "Challenging the illegal Attachment of Properties (Section 5 PMLA)",
            "Defending third-party bonafide purchasers whose properties are attached",
            "Appeals before the PMLA Appellate Tribunal and High Courts",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Overcoming Section 45 Bail Rigors",
        desc: "Secured a rare and critical bail order from the High Court in a high-profile PMLA case by demonstrating to the court that the ED lacked prime facie evidence linking the accused to the 'proceeds of crime'.",
        img: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Quashing ECIR Proceedings",
        desc: "Successfully petitioned the Supreme Court to quash an ongoing PMLA ECIR after securing an acquittal for the client in the underlying predicate (scheduled) offence.",
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },

  {
    id: "trademark-registration",
    icon: ClipboardList,
    title: "Trademark Registration & Prosecution",
    helmetTitle: "Trademark Registration Online in Delhi | Rai & Associates",
    helmetDescription:
      "Secure your brand name, logo, and slogan with professional trademark registration services in New Delhi. Expert intellectual property attorneys.",
    helmetKeywords:
      "trademark registration Delhi, online trademark filing, brand name registration, logo registration India, trademark attorney, intellectual property protection",
    bannerImage:
      "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=2000&auto=format&fit=crop",
    fullDesc: {
      intro:
        "A trademark is the ultimate legal shield for your brand's identity, protecting your unique name, logo, and slogan from unauthorized exploitation by competitors. At Rai & Associates, we simplify the complex intellectual property matrix. Our chambers provide comprehensive, end-to-end trademark prosecution services—ensuring your application is strategically categorized, flawlessly drafted, and vigorously defended before the Trademark Registry.",
      sections: [
        {
          title: "Comprehensive Brand Auditing & Search",
          content:
            "Filing a trademark without proper diligence frequently leads to costly objections and rejections under Section 9 and Section 11 of the Trade Marks Act. Before filing, our legal team conducts deep, exhaustive public searches across the comprehensive electronic registries to evaluate potential conflicts and determine the absolute registrability of your mark.",
        },
        {
          title: "Our End-to-End Registration Lifecycle",
          content:
            "We manage every phase of the prosecution timeline with tactical precision to secure your exclusive brand monopoly:",
          list: [
            "Accurate Classification of goods and services across all 45 statutory classes",
            "Drafting and Filing of TM-A applications for swift TM Application number generation",
            "Formulating robust, evidence-backed replies to official Examination Reports",
            "Representing clients in complex Show Cause hearings before the Registrar",
            "Handling Trademark Oppositions, Rectifications, and renewals to preserve validity",
          ],
        },
      ],
    },
    featureDetails: [
      {
        name: "Overcoming Section 11 Objections",
        desc: "Successfully argued and cleared severe Section 11 conflict objections for an expanding e-commerce enterprise, proving prior user rights and distinctiveness to secure the registration.",
        img: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800&auto=format&fit=crop",
      },
      {
        name: "Corporate Portfolio Management",
        desc: "Streamlined and secured trademark protection across multiple classes for a healthcare startup, establishing full structural brand immunity before their national market launch.",
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=800&auto=format&fit=crop",
      },
    ],
  },
];
